import './Iphone17.css';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useRef, useEffect } from "react";

import iPhone17All from '../../../../assets/apple/iPhone17/iphone17All.png';
import appleWatches from '../../../../assets/apple/iPhone17/appleWatches.png';

gsap.registerPlugin(ScrollTrigger);

function Iphone17() {
  const heroIntro = useRef(null);
  const heroPrice = useRef(null);
  const heroImage = useRef(null);
  const watchIntro = useRef(null);
  const watchPrice = useRef(null);
  const watchImage = useRef(null);
  const watchModels = useRef(null);

  useEffect(() => {
    // Hero section animation
    const tl = gsap.timeline();
    
    tl.fromTo(
      heroIntro.current,
      { y: 50, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: "power3.out" }
    )
    .fromTo(
      heroPrice.current,
      { y: 30, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.6, ease: "power2.out" },
      "-=0.4"
    )
    .fromTo(
      heroImage.current,
      { scale: 0.8, opacity: 0 },
      { scale: 1, opacity: 1, duration: 1, ease: "back.out(1.2)" },
      "-=0.3"
    );

    // Watch section scroll animations
    const watchAnimations = [
      gsap.fromTo(
        watchIntro.current,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: "power3.out",
          scrollTrigger: {
            trigger: watchIntro.current,
            start: "top 85%",
            end: "bottom 20%",
            toggleActions: "play none none none"
          }
        }
      ),
      gsap.fromTo(
        watchPrice.current,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          delay: 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: watchPrice.current,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        }
      ),
      gsap.fromTo(
        watchImage.current,
        { scale: 0.8, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          duration: 1,
          delay: 0.3,
          ease: "back.out(1.2)",
          scrollTrigger: {
            trigger: watchImage.current,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        }
      ),
      gsap.fromTo(
        watchModels.current,
        { y: 20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          delay: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: watchModels.current,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        }
      )
    ];

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
      watchAnimations.forEach(anim => anim.kill());
    };
  }, []);
return (
  <div className='iphone17-container'>
    <section className="iphone17-hero-new">
      <div className="hero-offer-banner">
        <p>Cardless 0% Interest EMI available, Plus upto ₹4,000 cash back on eligible credit cards.</p>
      </div>
      
      <div className="hero-content-new">
        <h2 ref={heroIntro} className="hero-intro" style={{ opacity: 0 }}>Introducing the iPhone 17 Series</h2>
        <p ref={heroPrice} className="hero-price" style={{ opacity: 0 }}>Starts at ₹82,900</p>
        <img
          ref={heroImage}
          src={iPhone17All}
          alt="iPhone 17 Series"
          className="hero-image-new"
          style={{ opacity: 0 }}
        />
      </div>
    </section>
    <section className="watch-section">
      <div className="watch-offer-banner">
        <p>Cardless 0% Interest EMI available, Plus upto ₹3,000 cash back on eligible credit cards.</p>
      </div>
      
      <div className="watch-content">
        <h2 ref={watchIntro} className="watch-intro" style={{ opacity: 0 }}>Meet the latest <strong>Apple Watch</strong>. Design for a Healthier you.</h2>
        <p ref={watchPrice} className="watch-price" style={{ opacity: 0 }}>Starts at ₹25,900</p>
        <img
          ref={watchImage}
          src={appleWatches}
          alt="Apple Watch"
          className="watch-image"
          style={{ opacity: 0 }}
        />
        <p ref={watchModels} className="watch-models" style={{ opacity: 0 }}>
          <span>SE (3rd Gen.)</span>
          <span className="separator">|</span>
          <span>Watch Ultra 3</span>
          <span className="separator">|</span>
          <span>Series 11</span>
        </p>
      </div>
    </section>  
    </div>
  );
}

export default Iphone17;
